import { useEffect, useState } from 'react';

// 모듈 수준 캐시 — 페이지 내 여러 AdSenseSlot이 있어도 API를 1회만 호출
let _promise = null;

function fetchConfig() {
  if (!_promise) {
    _promise = fetch('/api/public/settings/adsense')
      .then((r) => (r.ok ? r.json() : { enabled: false }))
      .catch((err) => {
        console.warn('[AdSense] 설정 로드 실패:', err.message);
        return { enabled: false };
      });
  }
  return _promise;
}

/**
 * AdSense 설정을 로드하는 커스텀 훅.
 * 로딩 중: null, 완료: { enabled, publisherId, headerSlotId, ... }
 */
export function useAdSense() {
  const [config, setConfig] = useState(null);

  useEffect(() => {
    fetchConfig().then(setConfig);
  }, []);

  return config;
}
